import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductCenter from "../pages/product-center/page";
import ProductDetail from "../pages/products/detail/page";
import AboutPage from "../pages/about/page";
import CasesPage from "../pages/cases/page";
import CaseDetailPage from "../pages/cases/detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/cases",
    element: <CasesPage />,
  },
  {
    path: "/cases/:slug",
    element: <CaseDetailPage />,
  },
  {
    path: "/product-center",
    element: <ProductCenter />,
  },
  {
    path: "/product-center/:slug",
    element: <ProductDetail />,
  },
  {
    path: "/product-center/:slug/:model",
    element: <ProductDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;